import { EdgeText, getStraightPath } from "reactflow";
import useColors from "../../../../api/hooks/useColors";
import CustomTooltip from "../../../../components/CustomTooltip";

const ScenarioSetEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data,
}) => {
  const colors = useColors();
  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={edgePath}
      />
      <CustomTooltip
        title={
          data?.isMitigated
            ? "Attack path mitigated by the previous Step"
            : data?.tooltip || ""
        }
      >
        <g>
          <path
            d={edgePath}
            fill="none"
            stroke="transparent"
            strokeWidth={20} // Increase hover area
            className="react-flow__edge-interaction"
          />
          {data?.isMitigated && (
            <>
              {/* X mark */}
              <text
                x={(sourceX + targetX) / 2}
                y={(sourceY + targetY) / 2}
                fill={colors.grey_600}
                fontSize="24px"
                fontWeight="bold"
                textAnchor="middle"
                dominantBaseline="middle"
                style={{
                  userSelect: "none",
                  pointerEvents: "none",
                }}
              >
                X
              </text>
            </>
          )}
        </g>
      </CustomTooltip>
      {data?.label && (
        <EdgeText
          x={labelX}
          y={labelY}
          label={data.label}
          labelStyle={{ fill: "black", fontWeight: "bold" }}
        />
      )}
    </>
  );
};

export default ScenarioSetEdge;
